import classNames from 'classnames';
import React, { useEffect } from 'react';
import { Button, LinkButton } from '../button/Button';
import { SegmentsMenuContent } from './SegmentsMenuContent';
import { useDelayedOffSwitch } from '../../../../../util/useDelayedOffSwitch';
import hamburger from './dash-3.svg';
import cross from './cross.svg';
import './NavMenuMobile.scss';
var CloseButton = function CloseButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    className: "close",
    onClick: onClick,
    "aria-label": "Close menu"
  }, /*#__PURE__*/React.createElement("img", {
    src: cross,
    alt: "Close"
  }));
};
var NavMenuMobileContent = function NavMenuMobileContent(_ref2) {
  var segments = _ref2.segments,
    open = _ref2.open,
    setOpen = _ref2.setOpen;
  var transition = useDelayedOffSwitch(open, 200);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('NavMenuMobile-content', {
      open: open,
      transition: transition
    })
  }, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: function onClick() {
      return setOpen(false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "NavMenuMobile-scrollable"
  }, /*#__PURE__*/React.createElement("h2", null, "How people use Milanote"), /*#__PURE__*/React.createElement(SegmentsMenuContent, {
    segments: segments
  }), /*#__PURE__*/React.createElement("div", {
    className: "bottom-links"
  }, /*#__PURE__*/React.createElement(LinkButton, {
    href: "/download-mobile-app"
  }, "Download the mobile apps"), /*#__PURE__*/React.createElement(LinkButton, {
    href: "https://app.milanote.com/"
  }, "Log in"), /*#__PURE__*/React.createElement(LinkButton, {
    href: "/register",
    cta: true
  }, "Sign up for free"))));
};
export var NavMenuMobile = function NavMenuMobile(_ref3) {
  var segments = _ref3.segments,
    open = _ref3.open,
    setOpen = _ref3.setOpen;
  useEffect(function () {
    // Prevent background scrolling when menu is open
    document.body.style.overflow = open ? 'hidden' : '';
    return function () {
      document.body.style.overflow = '';
    };
  }, [open]);
  return /*#__PURE__*/React.createElement("div", {
    className: "NavMenuMobile"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "hamburger",
    onClick: function onClick() {
      return setOpen(true);
    },
    "aria-label": "Toggle menu"
  }, /*#__PURE__*/React.createElement("img", {
    src: hamburger,
    alt: "Menu"
  })), /*#__PURE__*/React.createElement(NavMenuMobileContent, {
    segments: segments,
    open: open,
    setOpen: setOpen
  }));
};